import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

export class MobileNavigation {
  mobileToggle: HTMLButtonElement | null;
  mobileNav: HTMLDivElement | null;
  mobileBg: HTMLDivElement | null;
  mobileClose: HTMLButtonElement | null;

  isOpen: boolean;

  constructor() {
    this.mobileToggle = document.querySelector(".hamburger");
    this.mobileNav = document.querySelector(".mobile-navigation");
    this.mobileBg = document.querySelector(".mobile-navigation__bg");
    this.mobileClose = document.querySelector(".mobile-navigation__close");

    this.isOpen = false;
  }

  init = () => {
    if (this.mobileToggle && this.mobileNav) {
      this.mobileToggle.addEventListener("click", this.toggle);
    }

    if (this.mobileBg) {
      this.mobileBg.addEventListener("click", this.close);
    }

    if (this.mobileClose) {
      this.mobileClose.addEventListener("click", this.close);
    }

    window.addEventListener("keydown", this.onKeyDown);
  };

  onKeyDown = (event: KeyboardEvent) => {
    const { keyCode, which } = event;

    const key = which || keyCode;

    switch (key) {
      case 27: // Esc
        this.close();
        break;
      default:
      // Do nothing
    }
  };

  freezeVp = (event: KeyboardEvent) => {
    event.preventDefault();
  };

  toggle = () => {
    (this.isOpen ? this.close : this.open)();
  };

  open = () => {
    this.isOpen = true;

    if (this.mobileNav && this.mobileToggle) {
      this.mobileNav.classList.add("is-active");
      this.mobileToggle.classList.add("is-active");
      this.mobileToggle.setAttribute("aria-expanded", "true");

      disableBodyScroll(this.mobileNav);
    }
  };

  close = () => {
    this.isOpen = false;

    if (this.mobileNav && this.mobileToggle) {
      this.mobileNav.classList.remove("is-active");
      this.mobileToggle.classList.remove("is-active");
      this.mobileToggle.setAttribute("aria-expanded", "false");

      enableBodyScroll(this.mobileNav);
    }
  };
}

export default MobileNavigation;
